"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_native_1 = require("react-native");
const text_1 = __importStar(require("../../../components/text/text"));
const primaryButton_1 = __importDefault(require("../../../components/primaryButton/primaryButton"));
const colors_1 = __importDefault(require("../../../styles/colors"));
const webViewer_1 = __importDefault(require("../../../components/webViewer/webViewer"));
const MBSSmsNotReceived = ({ openLendigoLinks, connectZenithOrGtBank }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_TITLE, style: { fontSize: 20, marginBottom: 5, fontWeight: 'bold', textAlign: 'center' } }, t('myBankStatement.sms_not_received')),
        react_native_1.Platform.OS === 'web' ? (react_1.default.createElement(primaryButton_1.default, { title: "Click if you did not receive a SMS", onPress: () => openLendigoLinks('https://support.lendigo.ng/portal/en/kb/articles/common-reasons-why-you-may-not-have-received-the-ticket-id-password-sms-from-mybankstatement'), eventName: "go_to_Lendigo_instructions", color: colors_1.default.COLOR_CRITICAL })) : (react_1.default.createElement(webViewer_1.default, { windowHeight: "68%", docSrc: "https://support.lendigo.ng/portal/en/kb/articles/common-reasons-why-you-may-not-have-received-the-ticket-id-password-sms-from-mybankstatement" })),
        react_1.default.createElement(react_native_1.View, { style: react_native_1.Platform.OS !== 'web' ? { top: 40 } : { top: 0 } },
            react_1.default.createElement(primaryButton_1.default, { title: "I just received the sms", onPress: connectZenithOrGtBank, eventName: "tap_received_sms", color: colors_1.default.COLOR_PRIMARY }))));
};
exports.default = MBSSmsNotReceived;
